module.exports = __webpack_public_path__ + "static/img/logoSDHZ.1be69af3.png";